import { Box, BoxProps, Center, SimpleGrid } from '@chakra-ui/react';
import { Text } from './Text';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

type Element = {
    id: number;
    path: string;
    name: string;
    included: number[];
};

const elements: Element[] = [
    { id: 1, path: '/', name: 'introduction.title', included: [1] },
    { id: 2, path: '/general', name: 'general', included: [1, 2] },
    { id: 3, path: '/fileupload', name: 'fileupload', included: [1, 2, 3] },
    { id: 4, path: '/submit', name: 'submit', included: [1, 2, 3, 4] },
];

type Props = BoxProps & {
    boxSize: number;
};
export const ProgressBar = (props: Props) => {
    const { boxSize: _boxWith, ...rest } = props;
    const location = useLocation();
    const [selectedElement, setSelectedElement] = useState<Element>();

    const pathName = window.location.pathname;
    useEffect(() => {
        setSelectedElement(elements.find((item) => item.path === pathName));
    }, [location, pathName]);

    let boxSize = _boxWith / elements.length;
    const spacing = boxSize * 0.1;
    boxSize = boxSize - spacing;

    return (
        <SimpleGrid
            width={_boxWith}
            columns={[1, null, elements.length]}
            gap={4}
            bg="light.100"
            borderRadius={12}
        >
            {elements.map((item) => {
                return (
                    <Center height={6} width={boxSize} {...rest}>
                        <Box>
                            <Text
                                color={(selectedElement?.included ?? []).includes(item.id) ? 'black' : 'lightgrey'}
                                textDecoration={item.path === pathName ? 'underline' : 'None'}
                                trans={item.name}
                            />
                        </Box>
                    </Center>
                );
            })}
        </SimpleGrid>
    );
};
